import { tss } from 'tss-react/mui';

export const useStyles = tss.withName('Login').create(({ theme }) => ({
    root: {
        width: '100vw',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme.palette.grey[100],
    },

    loadingSpinner: {
        margin: '0 auto',
        display: 'block',
    },

    loginContainer: {
        minWidth: 300,
        maxWidth: 500,
        backgroundColor: theme.palette.background.paper,
        borderRadius: theme.spacing(1.5),
        boxShadow: '0 1px 2px 0 rgba(0,0,0,0.1), 0 6px 16px -2px rgba(0,0,0,0.1)',
        padding: theme.spacing(3),
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(3),
    },

    header: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',

        '& > p': {
            margin: theme.spacing(1, 0, 0),
            maxWidth: 275,
            textAlign: 'center',
            fontFamily: theme.typography.fontFamily,
            fontSize: '0.9rem',
            lineHeight: '1.3em',
            color: theme.palette.grey[500],
        },

        '& > p > a': {
            color: theme.palette.primary.main,
            textDecoration: 'none',
            fontWeight: 500,
            opacity: 0.75,
            transition: 'opacity 0.2s',
            cursor: 'pointer',

            '&:hover': {
                opacity: 1,
            },
        },
    },

    logoContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: theme.spacing(1),
    },

    logo: {},

    headerContainer: {
        display: 'flex',
        justifyContent: 'center',
        fontSize: '1.5rem',
        fontFamily: theme.typography.fontFamily,
    },

    infoContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: theme.spacing(2),
        margin: '0 auto',
        padding: theme.spacing(2, 3),
        textAlign: 'center',
        maxWidth: 325,
        width: '100%',
        boxSizing: 'border-box',
        background: theme.palette.grey[50],
        border: `1px solid ${theme.palette.grey[200]}`,
        borderRadius: theme.spacing(1),
        color: theme.palette.grey[700],

        fontFamily: theme.typography.fontFamily,
        fontSize: '1rem',

        ' & p': {
            margin: 0,
            lineHeight: '1.35em',
        },

        '& p a': {
            display: 'inline-block',
            color: theme.palette.primary.main,
            textDecoration: 'none',
            fontWeight: 500,
        },
    },

    reloadLink: {
        display: 'inline-block',
        padding: '8px 24px',
        background: '#1976d2',
        color: '#fff',
        borderRadius: theme.spacing(1.25),
        textDecoration: 'none',
        fontFamily: theme.typography.fontFamily,
        fontWeight: 400,
        transition: 'background 0.2s',
        cursor: 'pointer',
        '&:hover, &:focus': {
            background: '#1565c0',
        },
    },

    firebaseAuth: {
        '& .firebaseui-card-footer': {
            padding: 0,
        },

        '& .firebaseui-tos': {
            display: 'block',
            color: theme.palette.grey[500],
            marginTop: theme.spacing(1),

            '& > a': {
                color: theme.palette.primary.main,
                opacity: 0.65,
                textDecoration: 'none',
                fontWeight: 500,
                transition: 'opacity 0.2s',
                cursor: 'pointer',

                '&:hover': {
                    opacity: 1,
                },
            },
        },
    },

    loadingIndicator: {
        width: 24,
        height: 24,
        border: '3px solid #1976d2',
        borderTop: '3px solid #fff',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
        margin: '0 auto',
        display: 'block',

        '@keyframes spin': {
            from: { transform: 'rotate(0deg)' },
            to: { transform: 'rotate(360deg)' },
        },
    },
}));
